
const slidebarData = [
  // {
  //   name: 'Product',
  //   label: 'Product',
  //   link: 'product',
  //   icon: 'product'
  // },
  // {
  //   name: 'Outlet',
  //   label: 'Outlet',
  //   link: 'outlet',
  //   icon: 'outlet'
  // },
  // {
  //   name: 'Register',
  //   label: 'Register',
  //   link: 'register',
  //   icon: 'register'
  // },
  {
    name: 'Revenue',
    label: 'total_revenue',
    link: 'totalRevenue',
    icon: 'revenue'
  },
  {
    name: 'Orders',
    label: 'orders',
    link: 'numberOfOrders',
    icon: 'orders'
  },
  {
    name: 'Product Sold',
    label: 'products',
    link: 'productSold',
    icon: 'products'
  },
  {
    name: 'Tax',
    label: 'tax',
    link: 'tax',
    icon: 'tax'
  },
  {
    name: 'Global',
    label: 'global',
    link: 'global',
    icon: 'global'
  }
]

export default slidebarData
